import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["goalSelect", "linkInput", "fileInput"]

  connect() {
    this.toggleInputs()
  }

  toggleInputs() {
    const selectedGoal = this.goalSelectTarget.options[this.goalSelectTarget.selectedIndex]

    if (this.hasLinkInputTarget) {
      this.linkInputTarget.classList.add("d-none")
    }
    if (this.hasFileInputTarget) {
      this.fileInputTarget.classList.add("d-none")
    }

    if (this.hasLinkInputTarget && selectedGoal.dataset.showLinkForValue === "true") {
      this.linkInputTarget.classList.remove("d-none")
    }

    if (this.hasFileInputTarget && selectedGoal.dataset.showFileForValue === "true") {
      this.fileInputTarget.classList.remove("d-none")
    }
  }
}
